import { CuttingState } from "./CuttingState.d";
import { ShipmentState } from "./ShipmentState.d";
import { ShipmentType } from "./ShipmentType.d";
import { UserType } from "./UserType.d";
import { CordwoodMeasurementType } from "./CordwoodMeasurementType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity Prices


export interface Price {
    id: ID;

    
    pricingProfileId: ID;

    
    timberTypeId: ID;

    
    classId: ID;

    
    thicknessClassId?: ID;

    
    price: number;

    
    scopeGroupId: ID;

    }

export interface FilterAdvancedPresentationRequest {
    list: ListRequest,
    filter: {
        
            timberTypeId?: ID,
        
    
    

            classId?: ID,
        
    
    

            thicknessClassId?: ID,
        
    
    thicknessClassIdInclude: boolean,



        pricingProfileIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}



export interface CreatePrice {
    
    pricingProfileId: ID;

    
    timberTypeId: ID;

    
    classId: ID;

    
    thicknessClassId?: ID;

    
    price: number;

    
    }


export interface UpdatePrice {
    
    
    timberTypeId: ID;

    
    classId: ID;

    
    thicknessClassId?: ID;

    
    price: number;

    
    }

export interface PresentationPriceRequest {
    list: ListRequest,
    filter: {
        timberTypeId: ID,
        timberTypeIdOr: boolean,
        classId: ID,
        classIdOr: boolean,
        thicknessClassId: ID,
        thicknessClassIdOr: boolean,
        pricingProfileIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryPrice {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: Price): PrimaryPrice | undefined {
        return entity ? new PrimaryPrice(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryPrice {
        return new PrimaryPrice(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryPrice {
        let vals = path?.split('/');
        return new PrimaryPrice(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryPrice[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: Price): string {
    let fields = entity ? [
    entity.timberTypeId,
            entity.classId,
            entity.thicknessClassId,
            ] : [];
    return fields.filter(item => item).join(' | ');
}

export class UpdateEntityPrice {
    id: PrimaryPrice;
    data: UpdatePrice;


    constructor(id: PrimaryPrice, data: UpdatePrice) {
        this.id = id;
        this.data = data;
    }
}
